import React, { Fragment } from 'react';
import Slider from 'antd/lib/slider';
import InputNumber from 'antd/lib/input-number';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Checkbox from 'antd/lib/checkbox';

import { } from '../../../library/calc';

import { isRtl, modalPreferencesSubLabelFontSize } from '../../../library/constants';


export class IntegerStep extends React.Component {

  checkedBoxOptionsArray = ['show_ancestors'];
  checkedBoxes = [];
  didOnce = false;
  state = {
    ancestors: 0,
    descendants: 0,
    show_ancestors: 0,
    checkedBoxes: []
  };

  constructor(props){
    super(props);
    this.checkedBoxes = [];
    if( !this.props.isPedigree ){
      this.checkedBoxOptionsArray.forEach((key)=>{
        if(this.props.preferences.get(key) && !this.checkedBoxes.includes(key) ) this.checkedBoxes.push(key)
      })
    }

    this.setState({
      show_ancestors: this.props.preferences.get('show_ancestors'),
      ancestors: this.props.preferences.get('ancestors'),
      descendants: this.props.preferences.get('descendants'),
    });

  }

  onAncestorsChange = (value) => {
    this.setState({
      ancestors: value,
    });
  }

  onDecendantsChange = (value) => {
    this.setState({
      descendants: value,
    });
  }

  onSubmit(){

    const { ancestors, descendants, show_ancestors } = this.state;

    const callback = () => {
      this.props.hideModal();
    }

    this.props.postPreferences({
      ancestors,
      descendants,
      show_ancestors,
      callback,
    })
  }

  componentDidMount(){

    const callbackAfterPreferenceFetch = () => {

      this.checkedBoxes = [];
      if( !this.props.isPedigree ){
        this.checkedBoxOptionsArray.forEach((key)=>{
          if(this.props.preferences.get(key) && !this.checkedBoxes.includes(key) ) this.checkedBoxes.push(key)
        })
      }

      this.setState({
        show_ancestors: this.props.preferences.get('show_ancestors'),
        ancestors: this.props.preferences.get('ancestors'),
        descendants: this.props.preferences.get('descendants'),
      });

    }

    this.props.fetchPreferences({callbackAfterPreferenceFetch});

  }


  componentDidUpdate(){

    // console.log('componentDidUpdate');

  }

  onChange(checkedValues) {

    this.setState({
      show_ancestors: !this.state.show_ancestors,
    })

  }

  render() {

    this.checkBoxOptions = [
      { label: ( typeof(window.trl) !== 'undefined' ? window.trl('Direct ancestors only', 'Preferences Options', null):'Direct ancestors only'), value: 'show_ancestors', width:  80.951171875},
    ];

    // const notificationTitle = ( typeof(window.trl) !== 'undefined' ? window.trl('Notifications', 'Preferences Options', null): 'Notifications');

    const generationTitle = ( typeof(window.trl) !== 'undefined' ? window.trl('Generations to Display', 'Preferences Options', null): 'Generations to Display');
    const informAboutFourLevelsPedigree = ( typeof(window.trl) !== 'undefined' ? window.trl('The pedigree view always displays 4 generations of ancestors.', 'Preferences Options', null): 'The pedigree view always displays 4 generations of ancestors.');

    const inputNumberStyle= { marginLeft: 36, width: '50px'}
    const maxInput = ( this.props.chartType === 'fan' ? 7: 20);
    const minInput = ( this.props.chartType === 'fan' ? 4: 1);
    return (
      <div>
        {

            !this.props.isPedigree

                      ?

                <Fragment>
                  <Row>
                    <span style={{fontSize: `${modalPreferencesSubLabelFontSize}px`}}>{generationTitle}:</span><br/><br/>
                  </Row>
                  <Row>
                    <Col span={16} style={{ paddingLeft: 5 }}>{this.props.translatedLabels['Ancestors'].translatedLabel}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={19}>
                      <Slider reverse={ isRtl ? true: false } min={minInput} max={maxInput} onChange={this.onAncestorsChange} value={this.state.ancestors} />
                    </Col>
                    <Col span={3}>
                      <InputNumber
                        min={minInput}
                        max={maxInput}
                        style={inputNumberStyle}
                        value={this.state.ancestors}
                        onChange={this.onAncestorsChange}
                      />
                    </Col>
                  </Row>

                {

                      this.props.chartType !== 'fan'

                      ?
                          <Fragment>

                            <Row>
                              <Col span={16} style={{ paddingLeft: 5 }}>{this.props.translatedLabels['Descendants'].translatedLabel}
                              </Col>
                            </Row>
                            <Row>
                              <Col span={19}>
                                <Slider reverse={ isRtl ? true: false } min={minInput} max={maxInput} onChange={this.onDecendantsChange} value={this.state.descendants} />
                              </Col>
                              <Col span={3}>
                                <InputNumber
                                  min={minInput}
                                  max={maxInput}
                                  style={inputNumberStyle}
                                  value={this.state.descendants}
                                  onChange={this.onDecendantsChange}
                                />
                              </Col>
                            </Row>

                            <Row>
                              <br/>
                              <Checkbox.Group
                                options={this.checkBoxOptions}
                                defaultValue={this.checkedBoxes}
                                onChange={this.onChange.bind(this)} />
                            </Row>

                          </Fragment>
                      :

                      null

                }

                </Fragment>

                    :

                <Row>
                  <br/>
                  &nbsp;&nbsp;&nbsp;&nbsp;<span style={{fontSize: '16px'}}>{informAboutFourLevelsPedigree}</span>
                  <br/><br/>
                  <br/>

                </Row>




        }

      </div>
    );
  }
}
